import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import {
  Form,
  EditListingActionButton,
  FieldCheckbox,
  NamedLink,
  ExternalLink,
} from '../../components';

import css from './EditListingAcceptanceForm.css';

export const EditListingAcceptanceFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        values,
        form,
        onBackWithoutSubmit,
      } = formRenderProps;

      const acceptanceLabel = intl.formatMessage({
        id: 'EditListingAcceptanceForm.acceptanceLabel',
      });

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingAcceptanceForm.updateFailed" />
        </p>
      ) : null;
      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingAcceptanceForm.showListingFailed" />
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled =
        invalid ||
        disabled ||
        submitInProgress ||
        !(values && values.acceptance && values.acceptance.length > 0);

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <FieldCheckbox
            id="acceptance"
            name="acceptance"
            className={css.acceptance}
            value={'acceptance'}
            label={acceptanceLabel}
          />

          <p className={css.moreDescription}>
            <FormattedMessage
              id="EditListingAcceptanceForm.moreDescription"
              values={{
                termsLink: (
                  <NamedLink name="TermsOfServicePage">
                    <FormattedMessage id="EditListingAcceptanceForm.termsAndConditions" />
                  </NamedLink>
                ),
                auStandardLink: (
                  <ExternalLink href="https://www.productsafety.gov.au/product-safety-laws/safety-standards-bans/mandatory-standards">
                    <FormattedMessage id="EditListingAcceptanceForm.auStandard" />
                  </ExternalLink>
                ),
                productSafetyAuLink: (
                  <ExternalLink href="https://www.productsafety.gov.au/products">
                    <FormattedMessage id="EditListingAcceptanceForm.productSafetyAu" />
                  </ExternalLink>
                ),
                productSafetyRecallsLink: (
                  <ExternalLink href="https://www.productsafety.gov.au/recalls">
                    <FormattedMessage id="EditListingAcceptanceForm.productSafetyRecalls" />
                  </ExternalLink>
                ),
              }}
            />
          </p>

          <EditListingActionButton
            invalid={invalid}
            updateInProgress={updateInProgress}
            nextBtnMessage={saveActionMsg}
            nextBtnClassName={css.submitButton}
            form={form}
            onBackWithoutSubmit={onBackWithoutSubmit}
            submitInProgress={submitInProgress}
            submitReady={submitReady}
            submitDisabled={submitDisabled}
          />
        </Form>
      );
    }}
  />
);

EditListingAcceptanceFormComponent.defaultProps = {
  selectedPlace: null,
  updateError: null,
};

EditListingAcceptanceFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  selectedPlace: propTypes.place,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingAcceptanceFormComponent);
